import { Autocomplete } from "components";
import React, { useEffect, useState } from "react";
import SchoolServices from "services/SchoolServices";

/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const SchoolListDropDown = ({
  name,
  label,
  value,
  onChange,
  filter,
  required = false,
  validators = [],
  errorMessages = [],
  disabled = false,
}) => {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    ...filter,
    search: null,
    status: "Active",
  });

  // Update filters when the filter prop changes
  useEffect(() => {
    setFilters({
      ...filter,
      search: null,
      status: "Active",
    });
  }, [filter]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [data] = await Promise.all([
          SchoolServices.getAll({ ...filters }),
        ]);
        setData(data?.data?.view?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [filters]);

  // resolve the selected value: parent may pass the whole object or just the id
  const resolvedValue = (() => {
    if (!value) return null;
    if (typeof value === "object") return value;
    return data.find((item) => String(item.id) === String(value)) || null;
  })();

  return (
    <div>
      <Autocomplete
        name={name}
        label={label}
        value={resolvedValue}
        onChange={(event, newValue) => {
          if (onChange) onChange(event, newValue);
        }}
        options={data}
        getOptionLabel={(option) => {
          if (!option) return "";
          if (typeof option === "string" || typeof option === "number")
            return String(option);
          return (
            option?.name ||
            option?.category_name ||
            option?.display_name ||
            option?.label ||
            option?.title ||
            option?.description ||
            String(option?.id || "")
          );
        }}
        textInputOnChange={(e) => {
          setFilters({ ...filters, search: e.target.value });
        }}
        //isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.value === value?.value}
        required={required}
        validators={validators}
        errorMessages={errorMessages}
        disabled={disabled}
        TextFieldProps={{
          placeholder: "Select School",
        }}
      />
    </div>
  );
};

export default SchoolListDropDown;
